import useEventQuery from '../../../queries/hooks/useEventQuery';
import { EventInfo } from '@/api/event.types';

export const useEventInfo = (eventId: string): EventInfo => {
  const { data } = useEventQuery(eventId);
  return data.event;
};
